// Short-lived, draft-local cache. Saving always bypasses it for a fresh check.
export function createTransferSummaryCache({ ttlMs = 60000, now = Date.now } = {}) {
  let entry = null;
  return {
    clear() { entry = null; },
    async get(key, load, { force = false } = {}) {
      if (!force && entry?.key === key && (entry.pending || now() < entry.expiresAt)) {
        return entry.promise;
      }
      const next = { key, pending: true, expiresAt: 0 };
      entry = next;
      next.promise = Promise.resolve().then(load).then(value => {
        next.pending = false;
        next.expiresAt = now() + ttlMs;
        return value;
      }, error => {
        if (entry === next) entry = null;
        throw error;
      });
      return next.promise;
    },
  };
}
